import { takeLatest, put, call, select } from 'redux-saga/effects';
import { IAuthPayload } from '@kattana-io/common';
import { actionSetAuth, AUTH } from '../actions/auth';
import { setAuthToLS } from '../helpers/auth';
import { AuthAPI, UserAPI } from '../store/createStore';
import { actionCreateNotification } from '../actions/notifications';
import { StorageKeys } from '../helpers/localStorage';
import { authTokenSelector } from '../selectors/auth';

function* onAuth(action: any): any {
  try {
    const data = action.payload as IAuthPayload;
    const { ok, token } = yield call(AuthAPI.auth, data);

    if (!ok) {
      throw new Error('Something went wrong');
    }

    setAuthToLS({
      ...action.payload,
      sessionId: token.data.id,
    });

    yield put(
      actionSetAuth({
        loggedIn: true,
        authFailed: false,
        signature: data.signature,
        expires_at: Number(data.payload.expired_at),
        sessionId: token.data.id,
        wallet: data.payload.wallet,
        network: data.payload.network,
      })
    );
    yield put(
      actionCreateNotification({
        kind: 'info',
        message: 'You have been successfully authenticated!',
      })
    );
    if (window.localStorage) {
      const referral = window.localStorage.getItem(StorageKeys.referral);
      if (referral) {
        const authToken = yield select(authTokenSelector);
        const resp = yield call(
          UserAPI.activateReferral,
          data.payload.network,
          referral,
          authToken
        );
        if (resp?.status === 'User referrals updated') {
          window.localStorage.removeItem(StorageKeys.referral);
        }
      }
    }
  } catch (err) {
    yield put(
      actionCreateNotification({
        kind: 'error',
        message: 'Authentication failed',
      })
    );
    yield put(
      actionSetAuth({
        loggedIn: false,
        authFailed: true,
        signature: '',
        expires_at: 0,
        sessionId: 0,
        wallet: '',
        network: '',
      })
    );
    console.error(err);
  }
}

export default function* ratesSaga() {
  yield takeLatest(AUTH, onAuth);
}
